<template>
  <section
    :class="$store.getters['main/getBackgroundTone'](evenOdd)"
    :style="paddingCalculator"
  >
    <div class="text-with-images container">
      <div class="text-with-images__title tbc-medium font-38">
        {{ _.get(contentData, `conf.header.title`) }}
      </div>
      <div
        class="text-with-images__images"
        :class="{
          three: _.includes(_.get(contentData, 'conf.conf'), 'layout-3')
        }"
      >
        <image-with-desc
          v-for="(data, index) in _.get(contentData, 'data.list')"
          :key="index"
          :data="data"
          :noRoute="_.includes(_.get(contentData, 'conf.conf'), 'layout-3')"
        />
      </div>
    </div>
  </section>
</template>

<script>
import ImageWithDesc from "./ImageWithDesc.vue";

export default {
  props: ["contentData", "evenOdd"],
  components: { ImageWithDesc }
};
</script>

<style lang="scss" scoped>
.text-with-images {
  &__title {
    margin-bottom: 55px;
  }
  &__images {
    display: grid;
    margin-top: 55px;
    grid-template-columns: repeat(2, minmax(0px, 1fr));
    gap: 30px;
    &.three {
      grid-template-columns: repeat(3, minmax(0px, 1fr));
    }
    @media (max-width: 767px) {
      grid-template-columns: repeat(1, minmax(0px, 1fr));
      &.three {
        grid-template-columns: repeat(3, minmax(0px, 1fr));
      }
    }
  }
}
</style>
